import React from "react";
import { Phone } from "lucide-react";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { CONTACT } from "../../data/content";

export const FloatingCTA = () => {
  return (
    <div
      data-testid="floating-cta"
      className="md:hidden fixed bottom-4 inset-x-4 z-50 flex gap-3"
    >
      <a
        href={CONTACT.whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-btn"
        className="flex-1 inline-flex items-center justify-center gap-2 rounded-full bg-[#5AB82D] px-5 py-4 text-sm font-bold text-white shadow-[0_12px_30px_rgba(10,31,16,0.35)]"
      >
        <WhatsAppIcon className="w-5 h-5" /> WhatsApp
      </a>
      <a
        href={`tel:${CONTACT.phoneRaw}`}
        data-testid="floating-call-btn"
        className="inline-flex items-center justify-center rounded-full bg-white border border-black/10 w-14 h-14 shrink-0 text-[#0A1F10] shadow-[0_12px_30px_rgba(10,31,16,0.2)]"
        aria-label="Llamar"
      >
        <Phone className="w-5 h-5" />
      </a>
    </div>
  );
};
